import classNames from "classnames";
import { BG_COLORS } from "constant/app";
import PropTypes from "prop-types";
import React from "react";

class InfoBox extends React.Component {
  static get displayName() {
    return "InfoBox";
  }

  static get propTypes() {
    return {
      className: PropTypes.string,
      color: PropTypes.oneOf(BG_COLORS).isRequired,
      desc: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      subText: PropTypes.string,
      title: PropTypes.node.isRequired,
    };
  }

  render() {
    const { className, color, desc, icon, subText, title } = this.props;

    return (
      <div className={classNames("info-box", `bg-${color}`, className)}>
        <span className="info-box-icon">
          <i className={classNames("fa", `fa-${icon}`)} />
        </span>
        <div className="info-box-content">
          <span className="info-box-text">{title}</span>
          <span className="info-box-number">{desc}</span>
          <span className="progress-description">{subText}</span>
        </div>
      </div>
    );
  }
}

export default InfoBox;
export { InfoBox };
